import React from 'react';
import StoryblokReact from 'storyblok-react';
import { BaseBlok, BlokToComponentProps } from './types';

export const blokToComponent = <T extends BaseBlok>(
  props: BlokToComponentProps<T>,
  keyPrefix?: string,
): JSX.Element | null => {
  if (!props.blok) {
    return null;
  }

  const CustomChild = props.getComponent(props.blok.component);
  if (!CustomChild) {
    return null;
  }

  // eslint-disable-next-line no-underscore-dangle
  const key = typeof keyPrefix === 'string' ? `${keyPrefix}-${props.blok._uid}` : undefined;
  const newProps = {
    ...props,
    ...(key ? { key } : {}),
  };
  return (
    // @ts-expect-error StoryblokReact type has no children in props but renders them properly
    <StoryblokReact {...newProps} content={props.blok}>
      <CustomChild {...newProps}></CustomChild>
    </StoryblokReact>
  );
};
